var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.form.id
          ? _vm.form.editable
            ? "编辑进阶训练包"
            : "查看训练包详情"
          : "添加进阶训练包",
        visible: _vm.dialogVisible,
        "custom-class": "no-padding",
        width: "80%",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "advanced-contents",
          staticStyle: { height: "75vh" }
        },
        [
          _c(
            "div",
            { staticClass: "left" },
            [
              _vm.form.editable
                ? _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        "label-width": "130px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "15px" },
                          attrs: { label: "进阶包名称：", prop: "name" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              Z: "",
                              placeholder: "请输入"
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.type == 1
                        ? _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "15px" },
                              attrs: {
                                label: "所属分类：",
                                prop: "subjectCatalogueId"
                              }
                            },
                            [
                              _c("professional-tree", {
                                attrs: {
                                  root: 1,
                                  config: { checkStrictly: false }
                                },
                                model: {
                                  value: _vm.form.subjectCatalogueId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "subjectCatalogueId",
                                      $$v
                                    )
                                  },
                                  expression: "form.subjectCatalogueId"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { label: "进阶包封面：", prop: "coverImgs" }
                        },
                        [
                          _c("card-upload", {
                            attrs: {
                              "show-list": true,
                              limit: 1,
                              accept: ".png,.jpg,.jpeg",
                              "custom-style": {
                                width: "80",
                                height: "60px",
                                "font-size": "22px",
                                "margin-bottom": "0px"
                              }
                            },
                            model: {
                              value: _vm.form.coverImgs,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "coverImgs", $$v)
                              },
                              expression: "form.coverImgs"
                            }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "item-trip" }, [
                            _vm._v("注：建议图片尺寸宽高比 = 4:3")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fx-box" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: {
                                label: "每关题目数：",
                                prop: "testQuestionCount"
                              }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "60px" },
                                attrs: {
                                  controls: false,
                                  min: 5,
                                  max: 50,
                                  size: "small",
                                  placeholder: "请输入"
                                },
                                model: {
                                  value: _vm.form.testQuestionCount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "testQuestionCount", $$v)
                                  },
                                  expression: "form.testQuestionCount"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "color-777 font-12" }, [
                                _vm._v("说明：5~50题")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: { label: "难度系数：", prop: "difficulty" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { width: "60px" },
                                  attrs: {
                                    placeholder: "请选择",
                                    size: "mini"
                                  },
                                  model: {
                                    value: _vm.form.difficulty,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "difficulty", $$v)
                                    },
                                    expression: "form.difficulty"
                                  }
                                },
                                _vm._l(9, function(item) {
                                  return _c("el-option", {
                                    key: item,
                                    attrs: { label: item, value: item }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { label: "进阶考试次数：", prop: "examCount" }
                        },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "60px" },
                            attrs: {
                              controls: false,
                              min: 1,
                              max: 3,
                              size: "small",
                              placeholder: "请输入"
                            },
                            model: {
                              value: _vm.form.examCount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "examCount", $$v)
                              },
                              expression: "form.examCount"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "color-777 font-12" }, [
                            _vm._v("说明：1~3次")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "0px" },
                          attrs: {
                            label: "进阶考试题量：",
                            prop: "examQuestionCount"
                          }
                        },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "60px" },
                            attrs: {
                              controls: false,
                              min: 20,
                              max: 50,
                              size: "small",
                              placeholder: "请输入"
                            },
                            model: {
                              value: _vm.form.examQuestionCount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "examQuestionCount", $$v)
                              },
                              expression: "form.examQuestionCount"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "color-777 font-12" }, [
                            _vm._v("说明：20~50题")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btns" },
                        [
                          _vm.form.state <= 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.submitForm }
                                },
                                [_vm._v("生成")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "ul",
                    {
                      staticClass: "item-list",
                      staticStyle: { padding: "20px 30px" }
                    },
                    [
                      _c("li", [
                        _c("div", { staticClass: "keys" }, [
                          _vm._v("进阶包名称：")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "values" }, [
                          _vm._v(_vm._s(_vm.form.name))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "keys" }, [
                          _vm._v("每关题目数：")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "values" }, [
                          _vm._v(_vm._s(_vm.form.testQuestionCount))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "keys" }, [
                          _vm._v("难度系数：")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "values" }, [
                          _vm._v(_vm._s(_vm.form.difficulty))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.form.examCount > 0
                        ? _c("li", [
                            _c("div", { staticClass: "keys" }, [
                              _vm._v("进阶考试次数：")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "values" }, [
                              _vm._v(_vm._s(_vm.form.examCount))
                            ])
                          ])
                        : _vm._e()
                    ]
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "guanqia" },
                [
                  _c(
                    "el-collapse",
                    {
                      attrs: { accordion: true },
                      model: {
                        value: _vm.collapseId,
                        callback: function($$v) {
                          _vm.collapseId = $$v
                        },
                        expression: "collapseId"
                      }
                    },
                    _vm._l(_vm.packageList, function(item) {
                      return _c(
                        "el-collapse-item",
                        { key: item.id, attrs: { name: item.id } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", { staticClass: "order" }, [
                              _vm._v("第" + _vm._s(item.sort) + "阶")
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.name))]),
                            _vm._v(" "),
                            _vm.packageList.length > 1 && _vm.form.editable
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "guanqia-right",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "el-popconfirm",
                                      {
                                        attrs: {
                                          icon: "el-icon-info",
                                          "icon-color": "red",
                                          title: "确定删除此进阶吗？"
                                        },
                                        on: {
                                          confirm: function($event) {
                                            return _vm.deleteLevel(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: {
                                              slot: "reference",
                                              type: "danger",
                                              title: "删除进阶"
                                            },
                                            slot: "reference"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-delete"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "guanqia-content" },
                            _vm._l(item.children, function(data) {
                              return _c(
                                "div",
                                {
                                  key: data.id,
                                  staticClass: "guanqia-item",
                                  class: {
                                    active: _vm.curentLevel.id == data.id
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.getQuestions(data)
                                    }
                                  }
                                },
                                [
                                  data.type !== 20
                                    ? _c("span", { staticClass: "order" }, [
                                        _vm._v("第" + _vm._s(data.sort) + "关")
                                      ])
                                    : _c("span", { staticClass: "order" }, [
                                        _vm._v("进阶考试")
                                      ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(data.name))]),
                                  _vm._v(" "),
                                  data.type !== 20 && _vm.form.editable
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "guanqia-right",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                placement: "right",
                                                width: "400",
                                                trigger: "manual",
                                                "popper-class": "no-padding"
                                              },
                                              model: {
                                                value: data.popperShow,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    data,
                                                    "popperShow",
                                                    $$v
                                                  )
                                                },
                                                expression: "data.popperShow"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "edit-level" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "head" },
                                                    [_vm._v("添加关卡")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "body" },
                                                    [
                                                      data.popperShow
                                                        ? _c(
                                                            "el-form",
                                                            {
                                                              ref: "levelForm",
                                                              refInFor: true,
                                                              attrs: {
                                                                model:
                                                                  _vm.levelForm,
                                                                rules:
                                                                  _vm.levelRules,
                                                                "label-width":
                                                                  "80px"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "el-form-item",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "关卡名称",
                                                                    prop: "name"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-input",
                                                                    {
                                                                      attrs: {
                                                                        autocomplete:
                                                                          "off",
                                                                        Z: "",
                                                                        placeholder:
                                                                          "请输入"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .levelForm
                                                                            .name,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.levelForm,
                                                                            "name",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "levelForm.name"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-form-item",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "选择章节",
                                                                    prop:
                                                                      "curriculumChapterId"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-select",
                                                                    {
                                                                      attrs: {
                                                                        placeholder:
                                                                          "请选择"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .levelForm
                                                                            .curriculumChapterId,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.levelForm,
                                                                            "curriculumChapterId",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "levelForm.curriculumChapterId"
                                                                      }
                                                                    },
                                                                    _vm._l(
                                                                      _vm.chapters,
                                                                      function(
                                                                        item
                                                                      ) {
                                                                        return _c(
                                                                          "el-option",
                                                                          {
                                                                            key:
                                                                              item.value,
                                                                            attrs: {
                                                                              label:
                                                                                item.name,
                                                                              value:
                                                                                item.id
                                                                            }
                                                                          }
                                                                        )
                                                                      }
                                                                    ),
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-form-item",
                                                                {
                                                                  attrs: {
                                                                    label: " "
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-button",
                                                                    {
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.currentItem.popperShow = false
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "取消"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        type:
                                                                          "primary",
                                                                        loading:
                                                                          _vm.btnLoading
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.submitLevelForm
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "确定"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: {
                                                    slot: "reference",
                                                    type: "default",
                                                    title: "添加关卡"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showPopper(
                                                        data,
                                                        item
                                                      )
                                                    }
                                                  },
                                                  slot: "reference"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-plus"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-popconfirm",
                                            {
                                              attrs: {
                                                icon: "el-icon-info",
                                                "icon-color": "red",
                                                title: "确定删除该关卡吗？"
                                              },
                                              on: {
                                                confirm: function($event) {
                                                  return _vm.deleteLevel(
                                                    data,
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: {
                                                    slot: "reference",
                                                    type: "danger",
                                                    title: "删除关卡"
                                                  },
                                                  slot: "reference"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-delete"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        2
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c("div", { staticClass: "info" }, [
              _c("span", [
                _vm.curentLevel.type == 20
                  ? _c("span", { staticClass: "mr-5" }, [_vm._v("进阶考试")])
                  : _c("span", { staticClass: "mr-5" }, [
                      _vm._v("第" + _vm._s(_vm.curentLevel.sort || 0) + "关")
                    ]),
                _vm._v(_vm._s(_vm.curentLevel.name))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "ml-20" }, [
                _vm._v("题目数量：" + _vm._s(_vm.questions.length))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "questions" },
              _vm._l(_vm.questions, function(data, index) {
                return _c("single-question", {
                  key: index,
                  attrs: { data: data, index: index + 1, "is-edit": false },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "edit",
                        fn: function() {
                          return [
                            _vm.form.editable
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      plain: "",
                                      size: "mini"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.editQuestion("show", data)
                                      }
                                    }
                                  },
                                  [_vm._v("换题")]
                                )
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("关闭")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05e241bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e241bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/components/shared/AdvancedModal.vue
// module id = 591
// module chunks = 14